export class MessageReportGridViewModel {
  public reportId: number;
  public listId: number;
  public templateId: number;
  public messageName: string;
  public messageType: number;
  public messageSourceName: string;
  public sentBy: string;
  public folderName: string;
  public folderId: number;
  public totalSent: number;
  public totalBounces: number;
  public bounceRate: any;
  public totalOpens?: number;
  public totalDelivered?: number;
  public openRate?: any;
  public lastSentDate?: string;
  public sendDate?: string;
  public totalClicks?: number;
  public clickThroughRate?: any;
  public deliveredRate?: any;

  constructor(init: any) {
    this.reportId = init.ReportID;
    this.listId = init.ListID;
    this.templateId = init.TemplateID;
    this.messageName = init.MessageName;
    this.messageType = init.MessageType;
    this.messageSourceName = init.MessageSourceName;
    this.sentBy = init.SentBy;
    this.folderName = init.FolderName;
    this.lastSentDate = init.LastSentDate;
    this.sendDate = init.SendDate;
    this.folderId = init.FolderID;
    this.totalSent = init.TotalRecipients;
    this.totalOpens = init.TotalOpens;
    this.totalDelivered = init.TotalDelivered;
    this.openRate = init.OpenRate;
    this.totalBounces = init.TotalBounces;
    this.bounceRate = init.BounceRate;
    this.totalClicks = init.TotalClicks;
    this.clickThroughRate = init.ClickThroughRate;
    this.deliveredRate = init.DeliveredRate;
  }
}
